import _objectWithoutProperties from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import styled from 'styled-components';
import { layout } from 'styled-system';
import systemPropTypes from '@styled-system/prop-types';
import theme from './theme';
import { COMMON, get } from './constants';
import sx from './sx';
var Bar = styled.span.withConfig({
  displayName: "ProgressBar__Bar",
  componentId: "jrdkmi-0"
})(["width:", ";", ""], function (props) {
  return props.progress ? "".concat(props.progress, "%") : 0;
}, COMMON);
var sizeMap = {
  small: '5px',
  large: '10px',
  default: '8px'
};
var ProgressContainer = styled.span.withConfig({
  displayName: "ProgressBar__ProgressContainer",
  componentId: "jrdkmi-1"
})(["display:", ";overflow:hidden;background-color:", ";border-radius:", ";height:", ";", " ", " ", ";"], function (props) {
  return props.inline ? 'inline-flex' : 'flex';
}, get('colors.gray.2'), get('radii.1'), function (props) {
  return sizeMap[props.barSize];
}, COMMON, layout.width, sx);

var ProgressBar = function ProgressBar(_ref) {
  var progress = _ref.progress,
      bg = _ref.bg,
      theme = _ref.theme,
      rest = _objectWithoutProperties(_ref, ["progress", "bg", "theme"]);

  return /*#__PURE__*/React.createElement(ProgressContainer, _extends({
    theme: theme
  }, rest), /*#__PURE__*/React.createElement(Bar, {
    progress: progress,
    bg: bg,
    theme: theme
  }));
};

ProgressBar.displayName = "ProgressBar";
ProgressBar.defaultProps = {
  bg: 'green.5',
  barSize: 'default',
  theme: theme
};
export default ProgressBar;